import {Backdrop, CircularProgress, Container, styled} from "@mui/material";
import React from "react";
import {createStaticRanges, defaultStaticRanges} from "react-date-range";
import moment from "moment";

export const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))

export function CustomBackdrop (props) {
    return (
        <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}}
                  open={props.open}>
            <CircularProgress color={"inherit"}/>
        </Backdrop>
    )
}

// data range picker extra label
export const customRangeLabels = createStaticRanges([
    ...defaultStaticRanges,
    {
        label: "Last 3 months",
        range: () => ({
            startDate: moment().subtract(3, "month").toDate(),
            endDate: moment().endOf("day").toDate()
        })
    },
    {
        label: "This Year",
        range: () => ({
            startDate: moment().startOf("year").toDate(),
            endDate: moment().endOf("day").toDate()
        })
    },
    {
        label: "Last Year",
        range: () => ({
            startDate: moment().subtract(1, "year").startOf("year").toDate(),
            endDate: moment().subtract(1, "year").endOf("year").toDate()
        })
    }

])
